import LineClamp from './LineClampV2'

export type { LineClampProps } from './LineClampV2'
export default LineClamp
